import * as v from 'valibot';

export const BundleSchema = v.object({
  categories: v.array(v.number()),
  id: v.number(),
  name: v.string(),
  sessions: v.array(v.number()),
  uuid: v.string(),
  version: v.number(),
});

export const ProjectTypeSchema = v.fallback(
  v.union([
    v.literal('DESIGNED_PROJECT'),
    v.literal('PROJECT_SELECTION'),
    v.literal('SINGLE_PRODUCT_PROJECT'),
    v.literal('MICROLEARNING'),
    v.literal('MATERIAL_LIST_PROJECT'),
  ]),
  'DESIGNED_PROJECT',
);

export const isProjectSelection = (item?: {
  projectType?: TProjectType | null;
}): boolean => item?.projectType === 'PROJECT_SELECTION';

const SessionFormat = v.union([
  v.literal('face2face'),
  v.literal('online'),
  v.literal('hybrid'),
]);

export const SessionSchema = v.object({
  name: v.nullish(v.string()),
  description: v.nullish(v.string()),
  location: v.nullish(v.string()),
  language: v.nullish(v.string()),
  duration: v.nullish(v.number()),
  locale: v.nullish(v.string()),
  format: v.nullish(SessionFormat),
  version: v.number(),
  managed: v.boolean(),
  timezone: v.nullish(v.string()),
  uuid: v.string(),
  id: v.number(),
  anonymousAccess: v.boolean(),
  visibility: v.object({
    visibility: v.string(),
    show: v.boolean(),
    to: v.nullish(v.number()),
    from: v.nullish(v.number()),
  }),
  awardsAvailable: v.boolean(),
  certificatesAvailable: v.boolean(),
  diplomasAvailable: v.boolean(),
  bgColor: v.nullish(v.string()),
  categories: v.array(v.number()),
  enrollment: v.object({
    to: v.nullish(v.number()),
    from: v.nullish(v.number()),
    cancellable: v.boolean(),
    enabled: v.boolean(),
    mode: v.string(),
  }),
  disenrollment: v.object({
    to: v.nullish(v.number()),
    from: v.nullish(v.number()),
    enabled: v.boolean(),
    mode: v.string(),
  }),
  participantInfo: v.nullish(
    v.object({
      showName: v.boolean(),
      showThumbnail: v.boolean(),
      enabled: v.boolean(),
    }),
  ),
  waitlist: v.object({
    enabled: v.boolean(),
  }),
  startDate: v.nullish(v.string()),
  endDate: v.nullish(v.string()),
  // Type of the project behind the session. Older backends do not send it; treat missing as a regular course.
  projectType: v.nullish(ProjectTypeSchema),
});

export type TSession = v.Output<typeof SessionSchema>;
export type TBundle = v.Output<typeof BundleSchema>;
export type TSessionFormat = v.Output<typeof SessionFormat>;
export type TProjectType = v.Output<typeof ProjectTypeSchema>;
